var map = {
	"./statusCorrect.gif": "ddbe",
	"./statusCorrectChester.gif": "01b9",
	"./statusCorrectDusty.gif": "2028",
	"./statusCorrectLisa.gif": "4d12",
	"./statusCorrectPoppy.gif": "2f9c",
	"./statusCorrectTom.gif": "62e9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ce32";